import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AgentProvider } from './contexts/AgentContext';
import { Layout } from './components/Layout';
// Import pages
import { AIMapPage } from './pages/AIMapPage';
import { GovernancePage } from './pages/GovernancePage';
import { ImpostazioniPage } from './pages/ImpostazioniPage';
import { ServizioDetailPage } from './pages/ServizioDetailPage';
import { CostManagementPage } from './pages/CostManagementPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <AgentProvider data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<Layout data-id="element-4" />} data-id="element-3">
            {/* Redirect root to canvas */}
            <Route index element={<Navigate to="/canvas" replace data-id="element-6" />} data-id="element-5" />
            {/* Main Routes */}
            <Route path="canvas" element={<AIMapPage data-id="element-8" />} data-id="element-7" />
            <Route path="servizio/:agentId" element={<ServizioDetailPage data-id="element-10" />} data-id="element-9" />
            <Route path="costs" element={<CostManagementPage data-id="element-12" />} data-id="element-11" />
            <Route path="compliance" element={<GovernancePage data-id="element-14" />} data-id="element-13" />
            <Route path="impostazioni" element={<ImpostazioniPage data-id="element-16" />} data-id="element-15" />
            {/* Catch all - redirect to canvas */}
            <Route path="*" element={<Navigate to="/canvas" replace data-id="element-18" />} data-id="element-17" />
          </Route>
        </Routes>
      </AgentProvider>
    </BrowserRouter>;
}